import { maycaApi } from "../helpers/api_helper";
import { CustomerRepository } from "./customer";

export class ChatRepository {
  endpoint = "/chat";

  async getAll(filter, page, pageSize) {
    try {
      const response = await maycaApi.get(
        `${this.endpoint}/by-finalized?finalized=${filter}&page=${page}&pageSize=${pageSize}`
      );
      return response.data;
    } catch (err) {
      console.error("Error al obtener los chats:", err);
    }
  }

  async sendMessage(payload) {
    try {
      const response = await maycaApi.post(
        `${this.endpoint}/send-client`,
        payload
      );
      return response.data;
    } catch (err) {
      console.error("Error al enviar el mensaje:", err);
      throw err;
    }
  }

  async finalizeChat(chatId, customerId) {
    try {
      const response = await maycaApi.patch(
        `${this.endpoint}/${chatId}/${customerId}/finalize`
      );
      return response.data;
    } catch (err) {
      console.error("Error al finalizar el chat:", err);
      throw err;
    }
  }

  sortChats(chats) {
    return chats.sort((a, b) => {
      const lastMessageA = new Date(
        a.messages.length > 0
          ? a.messages[a.messages.length - 1].createdAt
          : a.createdAt
      );
      const lastMessageB = new Date(
        b.messages.length > 0
          ? b.messages[b.messages.length - 1].createdAt
          : b.createdAt
      );

      return lastMessageB - lastMessageA;
    });
  }

  formatChannel(channel, customerRepository) {
    const userInfo = null;
    const dateTime =
      channel.messages.length > 0
        ? new Date(channel.messages[channel.messages.length - 1].createdAt)
        : new Date(channel.createdAt);
    const formatted = this.formatDate(dateTime);
    const lastMessage =
      channel.messages.length > 0
        ? channel.messages[channel.messages.length - 1].message
        : "";
    return { ...channel, userInfo, time: formatted, lastMessage };
  }

  async getChatUsername(channel) {
    const customerRepository = new CustomerRepository();
    try {
      const res = await customerRepository.getCustomerById(
        channel.customer_user_id
      );
      return res;
    } catch {
      return false;
    }
  }

  formatDate(dateInMillis) {
    const date = new Date(dateInMillis);
    const today = new Date();

    const isSameDay =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    if (isSameDay) {
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    } else {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}/${month}/${year}`;
    }
  }
}

export default ChatRepository;
